module.exports = __webpack_public_path__ + "img/line.06f22efa.png";